import { v4 as uuid } from 'uuid';
import { SearchAggregationTimeUnit, SearchAggregationType, } from 'shared/domains/apollo/generated/types';
export const getDefaultDateRangeValue = (field) => ({
    type: SearchAggregationType.DateRange,
    name: uuid(),
    dateRangeInput: {
        field,
        ranges: [
            {
                fromNow: true,
                fromOffset: {
                    value: 0,
                    timeUnit: SearchAggregationTimeUnit.Day,
                    roundingTimeUnit: SearchAggregationTimeUnit.Day,
                },
                toNow: true,
                toOffset: {
                    value: 31,
                    timeUnit: SearchAggregationTimeUnit.Day,
                    roundingTimeUnit: SearchAggregationTimeUnit.Day,
                },
            },
            {
                fromNow: true,
                toNow: true,
                fromOffset: {
                    value: 31,
                    timeUnit: SearchAggregationTimeUnit.Day,
                    roundingTimeUnit: SearchAggregationTimeUnit.Day,
                },
                toOffset: {
                    value: 61,
                    timeUnit: SearchAggregationTimeUnit.Day,
                    roundingTimeUnit: SearchAggregationTimeUnit.Day,
                },
            },
            {
                fromNow: true,
                toNow: true,
                fromOffset: {
                    value: 61,
                    timeUnit: SearchAggregationTimeUnit.Day,
                    roundingTimeUnit: SearchAggregationTimeUnit.Day,
                },
                toOffset: {
                    value: 91,
                    timeUnit: SearchAggregationTimeUnit.Day,
                    roundingTimeUnit: SearchAggregationTimeUnit.Day,
                },
            },
        ],
    },
});
